import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Banner from './Banner';
import './Products.css';
import ChatBot from './ChatBot';

const Products = () => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [activeCategory, setActiveCategory] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch('https://joshmachapi.onrender.com/api/products/all');
                const data = await response.json();
                setProducts(data);
                setFilteredProducts(data);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchProducts();
    }, []);

    useEffect(() => {
        let result = products;
        if (activeCategory !== 'all') {
            result = result.filter(p => p.category?.toLowerCase().includes(activeCategory));
        }
        if (searchTerm) {
            result = result.filter(p => p.product_name?.toLowerCase().includes(searchTerm.toLowerCase()));
        }
        setFilteredProducts(result);
    }, [activeCategory, searchTerm, products]);

    const formatPrice = (price) => {
        return `KES ${price.toLocaleString('en-US')}`;
    };

    const handleProductClick = async (id) => {
        try {
            const response = await fetch(`https://joshmachapi.onrender.com/api/products/details?id=${id}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            navigate(`/product/${id}`, { state: { product: data } });
        } catch (error) {
            console.error('Error fetching product details:', error);
        }
    };

    const categories = [
        { key: 'all', label: 'All' },
        { key: 'prescription', label: 'Prescription' },
        { key: 'otc', label: 'OTC' },
        { key: 'vitamins', label: 'Vitamins' },
        { key: 'first aid', label: 'First Aid' },
    ];

    return (
        <div className="products-page">
            <Banner />
            
            {/* Categories & Search */}
            <div className="filter-section">
                <div className="category-pills">
                    {categories.map(cat => (
                        <button
                            key={cat.key}
                            className={`pill ${activeCategory === cat.key ? 'active' : ''}`}
                            onClick={() => setActiveCategory(cat.key)}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>
                <div className="search-box">
                    <input
                        type="text"
                        placeholder="Search products..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {/* Products Grid */}
            <div className="products-container">
                {filteredProducts.length === 0 && (
                    <div className="empty-state">
                        <p>No products available yet. Check back soon!</p>
                    </div>
                )}
                {filteredProducts.map(product => (
                    <div key={product.id} className="product" onClick={() => handleProductClick(product.id)}>
                        {product.discount && <div className="sale-badge">-{product.discount}%</div>}
                        <div className="product-img-wrap">
                            <img 
                                src={`${product.image_path}`} 
                                alt={product.product_name} 
                            />
                        </div>
                        <div className="product-info">
                            <span className="category">{product.category}</span>
                            <span className="name">{product.product_name}</span>
                            <div className="price-row">
                                <span className="price">{formatPrice(product.price)}</span>
                                {product.original_price && <span className="old-price">{formatPrice(product.original_price)}</span>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Prescription Upload CTA */}
            <div className="prescription-cta">
                <div className="prescription-cta-content">
                    <h2>Have a Prescription?</h2>
                    <p>Upload your prescription and we'll prepare your medication. Click the chat button below to upload.</p>
                    {localStorage.getItem('email') === 'eltonokoth59@gmail.com' && (
                        <button className="cta-btn" onClick={() => navigate('/prescription')}>
                            View Prescriptions
                        </button>
                    )}
                </div>
            </div>

            <ChatBot />
        </div>
    );
};

export default Products;
